module.exports = __webpack_public_path__ + "img/asset_SOL-USDC.b34e2691.png";